module.exports = __webpack_public_path__ + "img/why-invest-in-cryptocurrency.b1f99e5a.png";